export const TYPE_ITEMS = ['Lista de imóveis']
export const TYPE_ITEMS2 = ['Lista de imóveis','Link externo','Link interno - estatico','Link interno - pesquisa']
